import type { UserEntity, UserTableUI } from '@/domains/user/user.entity';

/**
 * Use Case para procesar usuarios para visualización en tabla
 *
 * Funcionalidad:
 * Transforma entidades de usuario desde API al formato requerido por la UI de tabla
 *
 * Responsabilidades:
 * - Convertir datos de UserEntity a UserTableUI
 * - Combinar nombres completos para visualización
 * - Validar y manejar arrays vacíos
 * - Extraer información de rol desde objeto anidado
 */
export class ProcessUserForTableUseCase {
  /**
   * Transforma un usuario individual al formato UI
   * Combina nombres y apellidos en un solo campo
   * Extrae información de rol desde estructura anidada
   * @param user - Entidad de usuario desde API
   */
  private transformUserToUI(user: UserEntity): UserTableUI {
    return {
      cod_funcionario: user.cod_funcionario,
      run: user.run,
      nombres:
        `${user.nombres_funcionario} ${user.apellido1_funcionario} ${user.apellido2_funcionario}`.trim(),
      mail: user.mail,
      cod_rol: user.rol?.cod_rol,
      rol: user.rol?.desc_rol,
      telefono: user.telefono,
      fecha_ingreso_sat: user.fecha_ingreso_sat,
    };
  }

  /**
   * Ejecuta la transformación de múltiples usuarios para tabla
   * @param user - Array de entidades de usuario desde API
   */
  exetucte(user: UserEntity[]): UserTableUI[] {
    if (!Array.isArray(user) || user.length === 0) return [];

    return user.map((user) => this.transformUserToUI(user));
  }
}
